import * as React from 'react';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import { Grid, Container } from '@mui/material';

export default function FirstStep(props) {
  const { handleClickButton } = props;
  return (
    <Container>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ maxWidth: 345, boxShadow: 3, textAlign: 'center' }}>
            <Button
              fullWidth
              onClick={() => handleClickButton('TypeRequest', 'AUTOMOBILE', 1)}
              variant="contained"
              color="primary"
            >
              AUTOMOBILE
            </Button>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ maxWidth: 345, boxShadow: 3, textAlign: 'center' }}>
            <Button
              fullWidth
              onClick={() => handleClickButton('TypeRequest', 'MOTO', 1)}
              variant="contained"
              color="primary"
            >
              MOTO
            </Button>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ maxWidth: 345, boxShadow: 3, textAlign: 'center' }}>
            <Button
              fullWidth
              onClick={() => handleClickButton('TypeRequest', 'AUTOCARRO', 1)}
              variant="contained"
              color="primary"
            >
              AUTOCARRO
            </Button>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
